import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import StorageService from "../services/StorageService";
import DailyReportService from "../services/DailyReportService";
import ProjectService from "../services/ProjectService";
import Breadcrumb from "../components/Breadcrumb";
import Loading from "../components/loading";
import ProjectWorkItemsService from "../services/ProjectWorkItemsService";
import usePermission from "../utils/UsePermission";
import ScreenData from "../config/ScreenData";
import ReactPaginate from "react-paginate";
import MessageDialog from "../components/MessageDialog";

export default function ViewDailyReport() {
  const navigate = useNavigate();

  // const messageTimer = useRef(null);

  const [loading, setLoading] = useState(false);       // API loading
  const [filtering, setFiltering] = useState(false);   // UI filtering loader
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("error"); // "success" or "error"

  const [confirmPopup, setConfirmPopup] = useState(false);
  const [confirmAction, setConfirmAction] = useState("");
  const [confirmReport, setConfirmReport] = useState(null);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [confirmNotes, setConfirmNotes] = useState("");
  const [statusDetailPopup, setStatusDetailPopup] = useState(false);
  const [statusDetailReport, setStatusDetailReport] = useState(null);

  const [projects, setProjects] = useState([]);
  const [allReports, setAllReports] = useState([]);
  const [filteredReports, setFilteredReports] = useState([]);

  const [selectedProject, setSelectedProject] = useState("");
  // const [selectedDate, setSelectedDate] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedId, setSelectedId] = useState(null);
  const emp = StorageService.loginData();

  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  const [activeTab, setActiveTab] = useState("work");

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  const openConfirmPopup = (rep, action) => {
    const missing = [];

    const hasWorkProgress =
      Array.isArray(rep.items) &&
      rep.items.some(item => item.workItemId);

    const hasMaterialConsumption =
      Array.isArray(rep.materialItems) &&
      rep.materialItems.some(item => item.itemId);

    const hasLabour =
      Array.isArray(rep.labourItems) &&
      rep.labourItems.some(item => item.vendorId);

    if (!hasWorkProgress) {
      missing.push("Work Progress");
    }

    if (!hasMaterialConsumption) {
      missing.push("Material Consumption");
    }

    if (!hasLabour) {
      missing.push("Labour Details");
    }

    let message = "";

    if (missing.length === 0) {
      message =
        "All required details are entered.\n\n" +
        `Are you sure you want to ${action} this report?`;
    } else {
      message =
        `${missing.join(", ")} ${
          missing.length === 1 ? "is" : "are"
        } not entered.\n\n` +
        `Are you sure you want to ${action} this report?`;
    }

    setConfirmReport(rep);
    setConfirmAction(action);
    setConfirmMessage(message);
    setConfirmNotes("");
    setConfirmPopup(true);
  };

  const closeConfirmPopup = () => {
    setConfirmPopup(false);
    setConfirmReport(null);
    setConfirmAction("");
    setConfirmMessage("");
    setConfirmNotes("");
  };

  const openStatusDetailPopup = (report) => {
    setStatusDetailReport(report || null);
    setStatusDetailPopup(true);
  };

  const closeStatusDetailPopup = () => {
    setStatusDetailPopup(false);
    setStatusDetailReport(null);
  };

  const { permission, checkView, can } = usePermission(
    ScreenData.Daily_Report,
    showMessage
  );

  useEffect(() => {
    if (permission) {
      checkView();
    }
  }, [permission]);

  useEffect(() => {
    loadProjects();
    fetchReports();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, []);

  // // 🔹 LOAD PROJECTS (Super Admin / Normal User)
  // const loadProjects = async () => {
  //   const emp = StorageService.loginData();
  //   const comp = StorageService.activeCompany();

  //   try {
  //     let projectsData = [];

  //     if (
  //       emp.roleName === "Super Admin" ||
  //       emp.roleName === "SuperAdmin" ||
  //       Number(emp.roleId) === 1
  //     ) {
  //       const res = await ProjectService.getActive(comp.companyId);
  //       projectsData = (res || []).map(p => ({
  //         projectId: p.id,
  //         projectName: p.projectName
  //       }));
  //     } else {
  //       const res = await ProjectService.getAssignedProjects(
  //         comp.companyId,
  //         emp.employeeId
  //       );
  //       projectsData = res?.data?.data || [];
  //     }

  //     setProjects(projectsData);
  //   } catch (err) {
  //     console.error(err);
  //     setProjects([]);
  //   }
  // };

  // const groupReports = (data) => {
  //   const grouped = {};

  //   data.forEach((item) => {
  //     // const key = `${item.projectId}-${item.reportDate}-${item.description}`;
  //     // const key = `${item.projectId}-${item.reportDate}`;
  //     const key = `${item.projectId}-${item.reportDate}-${item.status}`;

  //     if (!grouped[key]) {
  //       grouped[key] = {
  //         ...item,
  //         items: []
  //       };
  //     }

  //     grouped[key].items.push(item);
  //   });

  //   return Object.values(grouped);
  // };

  const groupReports = (data) => {
    const grouped = {};

    data.forEach((item) => {
      // const key = `${item.projectId}-${item.reportDate}-${item.status}`;
      const key =
        `${item.projectId}-${item.locationId}-${item.reportDate}-${item.status}`;

      if (!grouped[key]) {
        grouped[key] = {
          ...item,
          items: [...(item.items || [])],
          materialItems: [...(item.materialItems || [])],
          labourItems: [...(item.labourItems || [])]
        };
      } else {
        grouped[key].items.push(
          ...(item.items || [])
        );

        grouped[key].materialItems.push(
          ...(item.materialItems || [])
        );

        grouped[key].labourItems.push(
          ...(item.labourItems || [])
        );
      }
    });

    return Object.values(grouped);
  };

  // const groupReports = (data) => {
  //   const grouped = {};

  //   data.forEach((item) => {
  //     const key = `${item.projectId}-${item.reportDate}-${item.status}`;

  //     if (!grouped[key]) {
  //       grouped[key] = {
  //         ...item,
  //         items: item.items || [],
  //         materialItems: item.materialItems || [],
  //         labourItems: item.labourItems || []
  //       };
  //     }
  //   });

  //   return Object.values(grouped);
  // };

  const loadProjects = async () => {
  const emp = StorageService.loginData();
  const comp = StorageService.activeCompany();

  try {
    let projectsData = [];

    // SUPER ADMIN + DATA ADMIN → ALL PROJECTS
    const isPrivilegedProjectUser =
      emp.roleName === "Super Admin" ||
      emp.roleName === "SuperAdmin" ||
      emp.roleName === "Data Admin" ||
      Number(emp.roleId) === 1 ||
      Number(emp.roleId) === 2;

    if (isPrivilegedProjectUser) {
      const res = await ProjectService.getActive(comp.companyId);

      projectsData = (res || []).map(p => ({
        projectId: p.id,
        projectName: p.projectName,
        projectCode: p.projectCode
      }));
    }

    // NORMAL USER → ASSIGNED PROJECTS
    else {
      const res = await ProjectService.getAssignedProjects(
        comp.companyId,
        emp.employeeId
      );

      projectsData = (res?.data?.data || []).map(p => ({
        projectId: p.projectId,
        projectName: p.projectName,
        projectCode: p.projectCode
      }));
    }

    setProjects(projectsData);

  } catch (err) {
    console.error("Error loading projects:", err);
    setProjects([]);
  }
};

  // const loadProjects = async () => { 
  //   const emp = StorageService.loginData();
  //   const comp = StorageService.activeCompany();

  //   try {
  //     let projectsData = [];

  //     // SUPER ADMIN → ALL PROJECTS
  //     if (
  //       emp.roleName === "Super Admin" ||
  //       emp.roleName === "SuperAdmin" ||
  //       Number(emp.roleId) === 1
  //     ) {
  //       const res = await ProjectService.getActive(comp.companyId);

  //       projectsData = (res || []).map(p => ({
  //         projectId: p.id,
  //         projectName: p.projectName,
  //         projectCode: p.projectCode
  //       }));
  //     }
  //     // NORMAL USER → ASSIGNED PROJECTS
  //     else {
  //       const res = await ProjectService.getAssignedProjects(
  //         comp.companyId,
  //         emp.employeeId
  //       );

  //       projectsData = (res?.data?.data || []).map(p => ({
  //         projectId: p.projectId,
  //         projectName: p.projectName,
  //         projectCode: p.projectCode
  //       }));
  //     }

  //     setProjects(projectsData);
  //   } catch (err) {
  //     console.error("Error loading projects:", err);
  //     setProjects([]);
  //   }
  // };

  const locations = [
    ...new Map(
      allReports
        .filter(r =>
          !selectedProject ||
          Number(r.projectId) === Number(selectedProject)
        )
        .map(r => [
          r.locationId,
          {
            id: r.locationId,
            name: r.locationName
          }
        ])
    ).values()
  ];


  // 🔹 LOAD REPORTS (Company based)
  const fetchReports = async () => {
    setLoading(true);
    try {
      const comp = StorageService.activeCompany();
      const emp = StorageService.loginData();

      // const res = await DailyReportService.getAll(currentPage, itemsPerPage);
      const res =
        await DailyReportService.getAll(

          currentPage,

          itemsPerPage,

          {

            companyId: comp?.companyId,

            projectId: selectedProject,

            locationId: selectedLocation,

            status: selectedStatus,

            fromDate,

            toDate

          }

        );
      // const reportList = res?.data || [];
      const reportList = res?.data?.data || [];
      console.log(
        "VIEW RESPONSE",
        JSON.stringify(reportList, null, 2)
      );

      // normalize projectId
      const normalized = reportList.map(r => ({
        ...r,
        projectId: r.projectId ?? r.projectid
      }));

      let allowedProjectIds = [];

      // const isSuperAdmin =
      //   emp.roleName === "Super Admin" ||
      //   emp.roleName === "SuperAdmin" ||
      //   Number(emp.roleId) === 1;

      // if (isSuperAdmin) {
      //   // ✅ SUPER ADMIN → ALL COMPANY PROJECTS
      //   const projRes = await ProjectService.getActive(comp.companyId);
      //   allowedProjectIds = (projRes || []).map(p => Number(p.id));
      // } else {
      //   // ✅ NORMAL USER → ONLY ASSIGNED PROJECTS
      //   const projRes = await ProjectService.getAssignedProjects(
      //     comp.companyId,
      //     emp.employeeId
      //   );

      //   allowedProjectIds = (projRes?.data?.data || []).map(p =>
      //     Number(p.projectId || p.id)
      //   );
      // }

      const isPrivilegedProjectUser =
  emp.roleName === "Super Admin" ||
  emp.roleName === "SuperAdmin" ||
  emp.roleName === "Data Admin" ||
  Number(emp.roleId) === 1 ||
  Number(emp.roleId) === 2;

if (isPrivilegedProjectUser) {

  // SUPER ADMIN + DATA ADMIN → ALL COMPANY PROJECTS
  const projRes = await ProjectService.getActive(
    comp.companyId
  );

  const projList = Array.isArray(projRes) ? projRes : (projRes?.data || []);
  allowedProjectIds = projList.map(p =>
    Number(p.id || p.projectId)
  );

} else {

  // NORMAL USER → ONLY ASSIGNED PROJECTS
  const projRes =
    await ProjectService.getAssignedProjects(
      comp.companyId,
      emp.employeeId
    );

  allowedProjectIds =
    (projRes?.data?.data || []).map(p =>
      Number(p.projectId || p.id)
    );
}

      // ✅ FILTER REPORTS BASED ON ALLOWED PROJECTS
      const allowedReports = normalized.filter(r =>
        allowedProjectIds.includes(Number(r.projectId))
      );

      const groupedReports = groupReports(allowedReports);

      setAllReports(groupedReports);
      setFilteredReports(groupedReports);
      setPageCount(res?.pagination?.totalPages || 1);

      // setAllReports(allowedReports);
      // setFilteredReports(allowedReports);
    } catch (err) {
      console.error(err);
      showMessage("Failed to fetch reports.");
    } finally {
      setLoading(false);
    }
  };

  // 🔹 LIVE FILTER (Project + Date)
  // 🔹 LIVE FILTER (Project + Location + Status + Date + Search)
  // useEffect(() => {
  //   // Clear selection on any filter change
  //   setSelectedId(null);

  //   // If no filter criteria, show all reports
  //   if (!selectedProject && !selectedLocation && !selectedStatus && !fromDate && !toDate) {
  //     setFilteredReports(allReports);
  //     return;
  //   }

  //   setFiltering(true);
  //   const timer = setTimeout(() => {
  //     let data = [...allReports];

  //     if (selectedProject) {
  //       data = data.filter(r => Number(r.projectId) === Number(selectedProject));
  //     }

  //     if (selectedLocation) {
  //       data = data.filter(r => Number(r.locationId) === Number(selectedLocation));
  //     }

  //     if (selectedStatus) {
  //       data = data.filter(
  //         r => r.status === selectedStatus
  //       );
  //     }

  //     if (fromDate && toDate) {
  //       data = data.filter(r => {
  //         const reportDate = new Date(r.reportDate);
  //         const from = new Date(fromDate);
  //         const to = new Date(toDate);
  //         return reportDate >= from && reportDate <= to;
  //       });
  //     }

  //     // if (searchTerm) {
  //     //   const lower = searchTerm.toLowerCase();
  //     //   data = data.filter(r => {
  //     //     const combined = `${r.projectName || ''} ${r.locationName || ''} ${r.workStatus || ''}`.toLowerCase();
  //     //     return combined.includes(lower);
  //     //   });
  //     // }

  //     setFilteredReports(data);
  //     setFiltering(false);
  //   }, 300);

  //   return () => clearTimeout(timer);
  // }, [selectedProject, selectedLocation, selectedStatus, fromDate, toDate, allReports]);



  // useEffect(() => {
  //   fetchReports();
  // }, [currentPage]);

  useEffect(() => {

    fetchReports();

  }, [

    currentPage,

    selectedProject,

    selectedLocation,

    selectedStatus,

    fromDate,

    toDate

  ]);

  // const handleSelect = (id) => {
  //   setSelected(prev =>
  //     prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
  //   );
  // };

  // const handleSelectAll = (e) => {
  //   if (e.target.checked)
  //     setSelected(filteredReports.map(r => r.id));
  //   else setSelected([]);
  // };

  const handleClearFilters = () => {
    const hasFilters =
      selectedProject !== "" ||
      selectedLocation !== "" ||
      fromDate !== "" ||
      toDate !== "" ||
      selectedStatus !== "" ||
      selectedId !== null ||
      currentPage !== 1;

    setSelectedProject("");
    setSelectedLocation("");
    setFromDate("");
    setToDate("");
    setSelectedStatus("");
    setSelectedId(null);
    setCurrentPage(1);

    if (!hasFilters) {
      fetchReports();
    }
  };

  const handleAdd = () => {
    if (!can("canAdd")) {
      showMessage("No permission", "error");
      return;
    }
    setSelectedId(null);   //  clear selection
    navigate("/cpnl/dailyreport/add");
  };

  const handleModify = () => {
    if (!can("canModify")) {
      showMessage("No permission", "error");
      return;
    }
    if (!selectedId) {
      showMessage("Please select only one record to modify.");
      return;
    }

    const report = filteredReports.find(r => r.id === selectedId);
    if (!report) return;

    if (report.status !== "PENDING") {
      showMessage("Only PENDING reports can be modified.");
      return;
    }

    //  CHECK ROLE
    // const isSuperAdmin =
    //   emp.roleName === "Super Admin" ||
    //   emp.roleName === "SuperAdmin" ||
    //   Number(emp.roleId) === 1;

    // if (!isSuperAdmin) {

    const isPrivilegedDateUser =
  emp.roleName === "Super Admin" ||
  emp.roleName === "SuperAdmin" ||
  emp.roleName === "Data Admin" ||
  Number(emp.roleId) === 1 ||
  Number(emp.roleId) === 2;

if (!isPrivilegedDateUser) {
      //  NORMAL USER → CAN EDIT ONLY TODAY
      const today = new Date();
      const reportDate = new Date(report.reportDate);

      const todayStr =
        today.getFullYear() +
        "-" +
        String(today.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(today.getDate()).padStart(2, "0");

      const reportDateStr =
        reportDate.getFullYear() +
        "-" +
        String(reportDate.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(reportDate.getDate()).padStart(2, "0");

      if (todayStr !== reportDateStr) {
        showMessage(
          "You can modify only today's report.",
          "error"
        );
        return;
      }
    }

    //  ALLOWED → NAVIGATE
    navigate(`/cpnl/dailyreport/add/${selectedId}`);
  };

  // const handleApprove = async (id) => {

  //   try {

  //     await DailyReportService.approve(id, {
  //       approvedBy: emp.employeeId,
  //       approvedNotes: "Approved"
  //     });

  //     showMessage("Report approved successfully", "success");

  //     fetchReports();

  //   } catch (error) {

  //     showMessage("Approval failed");

  //   }

  // };

  // const handleApprove = async (rep) => {
  //   if (!can("canApprove")) {
  //     showMessage("No permission", "error");
  //     return;
  //   }
  //   const confirmAction = window.confirm("Are you sure you want to APPROVE this report?");
  //   if (!confirmAction) return;

  //   try {

  //     await DailyReportService.approve({
  //       // projectId: rep.projectId,
  //       // reportDate: rep.reportDate.split("T")[0],
  //       id: rep.id,
  //       approvedBy: emp.employeeId,
  //       approvedNotes: "Approved"
  //     });

  //     showMessage("Report approved successfully", "success");

  //     fetchReports();

  //   }
  //   // catch (error) {
  //   //   // showMessage("Approval failed");

  //   // }

  //   catch (error) {
  //     console.log(error.response);

  //     showMessage(
  //       error.response?.data?.message || error.message,
  //       "error"
  //     );
  //   }
  // };

  const handleApprove = (rep) => {
  if (!can("canApprove")) {
    showMessage("No permission", "error");
    return;
  }

  openConfirmPopup(rep, "APPROVE");
};

  // const handleReject = async (rep) => {

  //   if (!can("canReject")) {
  //     showMessage("No permission", "error");
  //     return;
  //   }

  //   const confirmAction = window.confirm("Are you sure you want to REJECT this report?");
  //   if (!confirmAction) return;

  //   try {

  //     await DailyReportService.reject({
  //       // projectId: rep.projectId,
  //       // reportDate: rep.reportDate.split("T")[0],
  //       id: rep.id,
  //       rejectedBy: emp.employeeId,
  //       rejectNotes: "Rejected"
  //     });

  //     showMessage("Report rejected successfully", "success");
  //     fetchReports();

  //   } catch (error) {
  //     showMessage("Reject failed");
  //   }
  // };

  const handleReject = (rep) => {
  if (!can("canReject")) {
    showMessage("No permission", "error");
    return;
  }

  openConfirmPopup(rep, "REJECT");
};

  // const handleCancel = async (rep) => {

  //   if (!can("canCancel")) {
  //     showMessage("No permission", "error");
  //     return;
  //   }

  //   const confirmAction = window.confirm("Are you sure you want to CANCEL this report?");
  //   if (!confirmAction) return;
  //   try {

  //     await DailyReportService.cancel({
  //       // projectId: rep.projectId,
  //       // reportDate: rep.reportDate.split("T")[0],
  //       id: rep.id,
  //       cancelledBy: emp.employeeId
  //     });

  //     showMessage("Report cancelled successfully", "success");
  //     fetchReports();

  //   } catch (error) {
  //     showMessage("Cancel failed");
  //   }
  // };

const handleCancel = (rep) => {
  if (!can("canCancel")) {
    showMessage("No permission", "error");
    return;
  }

  openConfirmPopup(rep, "CANCEL");
};

const confirmActionSubmit = async () => {
  if (!confirmReport) {
    return;
  }

  const enteredNotes = (confirmNotes || "").trim();

  try {
    if (confirmAction === "APPROVE") {
      await DailyReportService.approve({
        id: confirmReport.id,
        approvedBy: emp.employeeId,
        approvedNotes: enteredNotes || "Approved"
      });

      showMessage(
        "Report approved successfully",
        "success"
      );
    }

    else if (confirmAction === "REJECT") {
      await DailyReportService.reject({
        id: confirmReport.id,
        rejectedBy: emp.employeeId,
        rejectNotes: enteredNotes || "Rejected"
      });

      showMessage(
        "Report rejected successfully",
        "success"
      );
    }

    else if (confirmAction === "CANCEL") {
      await DailyReportService.cancel({
        id: confirmReport.id,
        cancelledBy: emp.employeeId
      });

      showMessage(
        "Report cancelled successfully",
        "success"
      );
    }

    closeConfirmPopup();
    fetchReports();

  } catch (error) {
    console.error(
      `${confirmAction} failed:`,
      error
    );

    showMessage(
      error.response?.data?.message ||
      error.message ||
      `${confirmAction} failed`,
      "error"
    );

    closeConfirmPopup();
  }
};

  const formatDate = (dateStr) =>
    dateStr ? new Date(dateStr).toLocaleDateString("en-GB") : "-";

  return (
    <>
      <Breadcrumb pageTitle="Daily Progress Report" secondTitle="projects" />
      <MessageDialog
        message={message}
        type={msgType}
        setMessage={setMessage}
        setMsgType={setMsgType}
      />

      {statusDetailPopup && statusDetailReport && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            backgroundColor: "rgba(0, 0, 0, 0.45)",
            zIndex: 1050
          }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "560px" }}>
            <div className="modal-content" style={{ borderRadius: "12px", overflow: "hidden", border: "none", boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.2), 0 8px 10px -6px rgba(0, 0, 0, 0.2)" }}>
              <div className="modal-header d-flex align-items-center justify-content-between" style={{ borderBottom: "1px solid #e5e7eb", padding: "1rem 1.25rem" }}>
                <div className="d-flex align-items-center gap-2">
                  <h5 className="modal-title" style={{ fontWeight: 700, fontSize: "1.35rem", margin: 0 }}>
                    {statusDetailReport.status} Details
                  </h5>
                  <span
                    className={`badge ${
                      statusDetailReport.status === "APPROVED"
                        ? "bg-success"
                        : statusDetailReport.status === "REJECTED"
                          ? "bg-danger"
                          : statusDetailReport.status === "CANCELLED"
                            ? "bg-dark"
                            : "bg-info text-dark"
                    }`}
                    style={{ fontSize: "0.75rem", padding: "0.3rem 0.55rem" }}
                  >
                    {statusDetailReport.status}
                  </span>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={closeStatusDetailPopup}
                ></button>
              </div>

              <div className="modal-body" style={{ padding: "1.25rem" }}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.85rem 1.25rem" }}>
                  <div>
                    <div style={{ color: "#6b7280", fontSize: "0.85rem", marginBottom: "0.2rem", fontWeight: 500 }}>Created By</div>
                    <div style={{ fontWeight: 600, color: "#1f2937" }}>{statusDetailReport.createdByName || statusDetailReport.createdBy || "-"}</div>
                  </div>
                  <div>
                    <div style={{ color: "#6b7280", fontSize: "0.85rem", marginBottom: "0.2rem", fontWeight: 500 }}>Created Date</div>
                    <div style={{ fontWeight: 600, color: "#1f2937" }}>{formatDate(statusDetailReport.createdDate || statusDetailReport.reportDate)}</div>
                  </div>

                  {statusDetailReport.status === "APPROVED" && (
                    <>
                      <div>
                        <div style={{ color: "#6b7280", fontSize: "0.85rem", marginBottom: "0.2rem", fontWeight: 500 }}>Approved By</div>
                        <div style={{ fontWeight: 600, color: "#1f2937" }}>{statusDetailReport.approvedByName || statusDetailReport.approvedBy || "-"}</div>
                      </div>
                      <div>
                        <div style={{ color: "#6b7280", fontSize: "0.85rem", marginBottom: "0.2rem", fontWeight: 500 }}>Approved Date</div>
                        <div style={{ fontWeight: 600, color: "#1f2937" }}>{formatDate(statusDetailReport.approvedDate)}</div>
                      </div>
                      <div style={{ gridColumn: "1 / -1" }}>
                        <div style={{ color: "#6b7280", fontSize: "0.85rem", marginBottom: "0.25rem", fontWeight: 500 }}>Approval Notes</div>
                        <div
                          style={{
                            fontWeight: 500,
                            minHeight: "40px",
                            whiteSpace: "pre-wrap",
                            backgroundColor: "#f9fafb",
                            border: "1px solid #e5e7eb",
                            borderRadius: "6px",
                            padding: "0.55rem 0.75rem",
                            color: "#374151",
                            fontSize: "0.9rem"
                          }}
                        >
                          {statusDetailReport.approvedNotes || <span style={{ color: "#9ca3af", fontStyle: "italic" }}>No approval notes provided</span>}
                        </div>
                      </div>
                    </>
                  )}

                  {statusDetailReport.status === "REJECTED" && (
                    <>
                      <div>
                        <div style={{ color: "#6b7280", fontSize: "0.85rem", marginBottom: "0.2rem", fontWeight: 500 }}>Rejected By</div>
                        <div style={{ fontWeight: 600, color: "#1f2937" }}>{statusDetailReport.rejectedByName || statusDetailReport.rejectedBy || "-"}</div>
                      </div>
                      <div>
                        <div style={{ color: "#6b7280", fontSize: "0.85rem", marginBottom: "0.2rem", fontWeight: 500 }}>Rejected Date</div>
                        <div style={{ fontWeight: 600, color: "#1f2937" }}>{formatDate(statusDetailReport.rejectedDate)}</div>
                      </div>
                      <div style={{ gridColumn: "1 / -1" }}>
                        <div style={{ color: "#6b7280", fontSize: "0.85rem", marginBottom: "0.25rem", fontWeight: 500 }}>Rejection Notes</div>
                        <div
                          style={{
                            fontWeight: 500,
                            minHeight: "40px",
                            whiteSpace: "pre-wrap",
                            backgroundColor: "#fef2f2",
                            border: "1px solid #fee2e2",
                            borderRadius: "6px",
                            padding: "0.55rem 0.75rem",
                            color: "#991b1b",
                            fontSize: "0.9rem"
                          }}
                        >
                          {statusDetailReport.rejectNotes || <span style={{ color: "#9ca3af", fontStyle: "italic" }}>No rejection notes provided</span>}
                        </div>
                      </div>
                    </>
                  )}

                  {statusDetailReport.status === "CANCELLED" && (
                    <>
                      <div>
                        <div style={{ color: "#6b7280", fontSize: "0.85rem", marginBottom: "0.2rem", fontWeight: 500 }}>Cancelled By</div>
                        <div style={{ fontWeight: 600, color: "#1f2937" }}>{statusDetailReport.cancelledByName || statusDetailReport.cancelledBy || "-"}</div>
                      </div>
                      <div>
                        <div style={{ color: "#6b7280", fontSize: "0.85rem", marginBottom: "0.2rem", fontWeight: 500 }}>Cancelled Date</div>
                        <div style={{ fontWeight: 600, color: "#1f2937" }}>{formatDate(statusDetailReport.cancelledDate)}</div>
                      </div>
                    </>
                  )}

                  {/* DIVIDER LINE BETWEEN TOP DETAILS AND PROJECT DETAILS */}
                  <div
                    style={{
                      gridColumn: "1 / -1",
                      display: "flex",
                      alignItems: "center",
                      gap: "0.75rem",
                      margin: "0.4rem 0 0.1rem"
                    }}
                  >
                    <div style={{ flex: 1, height: "1px", backgroundColor: "#e5e7eb" }}></div>
                    <span
                      style={{
                        fontSize: "0.75rem",
                        fontWeight: 700,
                        textTransform: "uppercase",
                        letterSpacing: "0.05em",
                        color: "#9ca3af"
                      }}
                    >
                      Project Details
                    </span>
                    <div style={{ flex: 1, height: "1px", backgroundColor: "#e5e7eb" }}></div>
                  </div>

                  <div>
                    <div style={{ color: "#6b7280", fontSize: "0.85rem", marginBottom: "0.2rem", fontWeight: 500 }}>Project</div>
                    <div style={{ fontWeight: 600, color: "#1f2937" }}>{statusDetailReport.projectName || "-"}</div>
                  </div>
                  <div>
                    <div style={{ color: "#6b7280", fontSize: "0.85rem", marginBottom: "0.2rem", fontWeight: 500 }}>Location</div>
                    <div style={{ fontWeight: 600, color: "#1f2937" }}>{statusDetailReport.locationName || "-"}</div>
                  </div>
                  <div>
                    <div style={{ color: "#6b7280", fontSize: "0.85rem", marginBottom: "0.2rem", fontWeight: 500 }}>Report Date</div>
                    <div style={{ fontWeight: 600, color: "#1f2937" }}>{formatDate(statusDetailReport.reportDate)}</div>
                  </div>
                  <div>
                    <div style={{ color: "#6b7280", fontSize: "0.85rem", marginBottom: "0.2rem", fontWeight: 500 }}>Work Status</div>
                    <div style={{ fontWeight: 600, color: "#1f2937" }}>{statusDetailReport.workStatus || "-"}</div>
                  </div>
                </div>
              </div>

              <div className="modal-footer" style={{ borderTop: "1px solid #f3f4f6", padding: "0.75rem 1.25rem" }}>
                <button type="button" className="btn btn-secondary px-4" onClick={closeStatusDetailPopup}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {confirmPopup && (
        <div
          className="modal fade show"
          style={{
            display: "block",
            backgroundColor: "rgba(0, 0, 0, 0.45)",
            zIndex: 1050
          }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "800px" }}>
            <div className="modal-content" style={{ borderRadius: "10px", overflow: "hidden" }}>
              <div className="modal-header" style={{ borderBottom: "1px solid #e5e7eb", padding: "1.25rem 1.5rem 1rem" }}>
                <h5 className="modal-title" style={{ fontWeight: 700, fontSize: "2rem", margin: 0 }}>
                  Confirm {confirmAction}
                </h5>

                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={closeConfirmPopup}
                  style={{ fontSize: "1.5rem" }}
                ></button>
              </div>

              <div className="modal-body" style={{ padding: "1.25rem 1.5rem 1rem" }}>
                <p
                  style={{
                    whiteSpace: "pre-line",
                    marginBottom: "1rem",
                    lineHeight: "1.5",
                    fontSize: "1.05rem",
                    color: "#2d3748"
                  }}
                >
                  {confirmMessage}
                </p>

                {confirmAction !== "CANCEL" && (
                  <>
                    <label className="form-label fw-semibold" style={{ fontSize: "0.95rem", marginBottom: "0.25rem" }}>
                      {confirmAction === "APPROVE"
                        ? "Approval Notes"
                        : "Rejection Notes"}
                    </label>
                    <textarea
                      className="form-control"
                      rows="2"
                      value={confirmNotes}
                      onChange={(e) => setConfirmNotes(e.target.value)}
                      placeholder={
                        confirmAction === "APPROVE"
                          ? "Enter approval notes..."
                          : "Enter rejection reason..."
                      }
                      style={{
                        resize: "vertical",
                        minHeight: "56px",
                        maxHeight: "90px",
                        fontSize: "0.92rem",
                        padding: "0.5rem 0.65rem"
                      }}
                    />
                  </>
                )}
              </div>

              <div className="modal-footer" style={{ borderTop: "1px solid #e5e7eb", padding: "0.9rem 1.5rem 1.1rem", justifyContent: "flex-end", gap: "0.75rem" }}>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeConfirmPopup}
                  style={{ minWidth: "90px", padding: "0.6rem 1.25rem", fontWeight: 600, fontSize: "1rem" }}
                >
                  No
                </button>

                <button
                  type="button"
                  className={
                    confirmAction === "APPROVE"
                      ? "btn btn-success"
                      : confirmAction === "REJECT"
                        ? "btn btn-danger"
                        : "btn btn-secondary"
                  }
                  onClick={confirmActionSubmit}
                  style={{ minWidth: "135px", padding: "0.6rem 1.2rem", fontWeight: 700, fontSize: "1rem" }}
                >
                  Yes, {confirmAction}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* <div className="card p-3 shadow-sm"> */}
      <div
        className="card shadow-sm mx-auto"
        style={{
          width: "98%",
          maxWidth: "1600px",
          minHeight: "700px"
        }}
      >
        <div className="card-body">
          {/* {message && (
          <div
            className={`alert alert-${msgType === "success" ? "success" : "danger"} alert-dismissible fade show`}
          >
            {message}
            <button
              type="button"
              className="btn-close"
              onClick={() => setMessage("")}
            ></button>
          </div>
        )} */}


          {/* 🔹 FILTER + ACTION BAR */}

          <div className="row mb-3">
            {/* <div className="row mb-3 align-items-end"> */}
            {/* Project */}
            <div className="col-md-2">
              <label className="form-label">Project</label>
              <select
                className="form-select"
                value={selectedProject}
                // onChange={(e) => setSelectedProject(e.target.value)}
                onChange={(e) => {
                  setSelectedProject(e.target.value);
                  setSelectedLocation("");
                  setCurrentPage(1);
                }}
              >
                <option value="">All Projects</option>
                {projects.map(p => (
                  <option key={p.projectId} value={p.projectId}>
                    {p.projectName}-{p.projectCode}
                  </option>
                ))}
              </select>
            </div>

            {/* Report Date */}
            {/* <div className="col-md-3">
              <label className="form-label">Report Date</label>
              <input
                type="date"
                className="form-control"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
              />
            </div> */}

            <div className="col-md-2">
              <label className="form-label">Location</label>

              <select
                className="form-select"
                value={selectedLocation}
                onChange={(e) => {
                  setSelectedLocation(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">All Locations</option>

                {locations.map(loc => (
                  <option key={loc.id} value={loc.id}>
                    {loc.name}
                  </option>
                ))}
              </select>
            </div>


            <div className="col-md-2">
              <label className="form-label">From Date</label>
              <input
                type="date"
                className="form-control"
                value={fromDate}
                onChange={(e) => {
                  setFromDate(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </div>

            <div className="col-md-2">
              <label className="form-label">To Date</label>
              <input
                type="date"
                className="form-control"
                value={toDate}
                onChange={(e) => {
                  setToDate(e.target.value);
                  setCurrentPage(1);
                }}
              />
            </div>

            <div className="col-md-2">
              <label className="form-label">Status</label>

              <select
                className="form-select"
                value={selectedStatus}
                onChange={(e) => {
                  setSelectedStatus(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">All Status</option>
                <option value="PENDING">Pending</option>
                <option value="APPROVED">Approved</option>
                <option value="REJECTED">Rejected</option>
                <option value="CANCELLED">Cancelled</option>
              </select>
            </div>

            {/* Clear Filter Button */}
            <div className="col-md-2 d-flex flex-column align-items-start">
              <label className="form-label invisible d-none d-md-block">Clear</label>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleClearFilters}
              >
                <i className="ti ti-refresh me-1"></i> Clear
              </button>
            </div>

          </div>

          {/* Buttons beside Date */}

          <div className="row mb-3">
            <div className="col-md-12 d-flex justify-content-end gap-2">

              {/* <div className="col-md-3 d-flex justify-content-end gap-2"> */}
              {can("canAdd") && (
                <button className="btn btn-success" onClick={handleAdd}>
                  Add
                </button>
              )}

              {can("canModify") && (
                <button className="btn btn-warning" onClick={handleModify}>
                  Modify
                </button>
              )}
            </div>


          </div>
          {/* 🔹 TABLE */}
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Select</th>
                  <th>Project</th>
                  <th>Report Date</th>
                  <th>Location</th>
                  <th>Work Status</th>
                  {/* <th>Vendor</th>
                <th>Skilled</th>
                <th>Unskilled</th> */}
                  <th></th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {loading || filtering ? (
                  <tr>
                    <td colSpan="14" className="text-center py-4">
                      {/* <div className="spinner-border text-primary"></div> */}
                      <Loading />
                      <div className="mt-2 text-muted">
                        {loading ? "Loading data..." : "Filtering data..."}
                      </div>
                    </td>
                  </tr>
                ) : filteredReports.length > 0 ? (
                  filteredReports.map(rep => {
                    console.log("WORK ITEMS =", rep.items);

                    // <tr key={rep.id}>
                    //   <td>
                    //     <input
                    //       type="radio"
                    //       name="dailyReportSelect"
                    //       checked={selectedId === rep.id}
                    //       onChange={() => setSelectedId(rep.id)}
                    //     />
                    //   </td>
                    //   <td>
                    //     {rep.projectName}
                    //     {rep.projectCode ? ` - ${rep.projectCode}` : ""}
                    //   </td>
                    //   <td>{formatDate(rep.reportDate)}</td>
                    //   <td>{rep.workItemDescription}</td>
                    //   <td>{rep.fromChainage}</td>
                    //   <td>{rep.toChainage}</td>
                    //  <td>{rep.locationName}</td>
                    //   <td>{rep.side}</td>
                    //   <td>{rep.UOM}</td>
                    //   <td>{rep.quantity}</td>
                    //   <td>{rep.vendorName}</td>
                    //   <td>{rep.skilledLabour}</td>
                    //   <td>{rep.unskilledLabour}</td>
                    //   <td>{rep.remarks}</td>
                    //   <td>{rep.description}</td>
                    // </tr>
                    return (
                      <tr key={rep.id}>
                        <td>
                          <input
                            type="radio"
                            name="dailyReportSelect"
                            checked={selectedId === rep.id}
                            onChange={() => setSelectedId(rep.id)}
                          />
                        </td>

                        <td>{rep.projectName}</td>

                        <td>{formatDate(rep.reportDate)}</td>

                        <td>{rep.locationName || "-"}</td>
                        <td>
                          <span
                          // className={`badge ${rep.workStatus === "IDLE"
                          //   ? "bg-warning text-dark"
                          //   : "bg-success"
                          //   }`}
                          >
                            {rep.workStatus || "WORKING"}
                          </span>
                        </td>


                        {/* <td>{rep.vendorName || "-"}</td>

                    <td>{rep.skilledLabour ?? "-"}</td>

                    <td>{rep.unskilledLabour ?? "-"}</td> */}

                        <td>

                          {rep.workStatus === "IDLE" ? (

                            <div className="p-2">

                              <h6>Idle Note</h6>

                              <div>
                                {rep.idleNote || "-"}
                              </div>

                            </div>

                          ) : (

                            <>

                              <h5 className="mt-3">Work Details</h5>

                              <ul className="nav nav-tabs mb-3">

                                <li className="nav-item">
                                  <button
                                    type="button"
                                    className={`nav-link ${activeTab === "work" ? "active" : ""}`}
                                    onClick={() => setActiveTab("work")}
                                  >
                                    Work Progress
                                  </button>
                                </li>

                                <li className="nav-item">
                                  <button
                                    type="button"
                                    className={`nav-link ${activeTab === "material" ? "active" : ""}`}
                                    onClick={() => setActiveTab("material")}
                                  >
                                    Material Consumption
                                  </button>
                                </li>

                                <li className="nav-item">
                                  <button
                                    type="button"
                                    className={`nav-link ${activeTab === "labour" ? "active" : ""}`}
                                    onClick={() => setActiveTab("labour")}
                                  >
                                    Working Labour
                                  </button>
                                </li>

                              </ul>

                              {/* <h6 className="mt-3">Work Progress</h6> */}
                              {activeTab === "work" && (
                                <table className="table table-bordered">
                                  <thead>
                                    <tr>
                                      {/* <th>From Ch</th>
                            <th>To Ch</th>
                            <th>Work Item</th>
                            <th>Side</th>
                            <th>Work Activity</th>
                            <th>UOM</th>
                            <th>Length</th>
                            <th>Breadth</th>
                            <th>Depth</th>
                            <th>Project Qty</th>
                            <th>Work Qty</th>
                            <th>Remarks</th>
                            <th>Description</th> */}


                                      {(rep.projectCategoryName === "Civil Works"
                                        // ||
                                        // rep.projectCategoryName === "Water Utility"
                                      ) ? (
                                        <th>Location</th>
                                      ) : (
                                        <>
                                          <th>From Ch</th>
                                          <th>To Ch</th>
                                        </>
                                      )}

                                      <th>Work Item</th>
                                      <th>Side</th>
                                      <th>Work Activity</th>
                                      <th>UOM</th>

                                      {(rep.projectCategoryName === "Civil Works"
                                        // ||
                                        // rep.projectCategoryName === "Water Utility"
                                      ) && (
                                          <>
                                            <th>Nos</th>
                                            <th>Length</th>
                                            <th>Breadth</th>
                                            <th>Depth</th>
                                          </>
                                        )}

                                      <th>Project Qty</th>
                                      <th>Work Qty</th>
                                      <th>Description</th>
                                      <th>Remarks</th>

                                    </tr>

                                  </thead>
                                  <tbody>
                                    {rep.items?.map((i, index) => (
                                      <>
                                        {console.log("ITEM =", i)}
                                        <tr key={i.id || index}>

                                          {/* <td>
                                {i.fromChainage}
                              </td>

                              <td>
                                {i.toChainage}
                              </td>


                              <td>
                                {i.workItemCode}
                              </td>

                              <td>
                                {i.side}
                              </td>

                              <td>
                                {i.workActivity || "-"}
                              </td>


                              <td>
                                {i.UOM}
                              </td>

                              <td>{i.length ?? "-"}</td>
                              <td>{i.breadth ?? "-"}</td>
                              <td>{i.depth ?? "-"}</td>


                              <td>{i.projectQuantity}</td>
                              <td>{i.workQuantity}</td>

                              <td>
                                {i.remarks}
                              </td> */}

                                          {/* <td>
                      {rep.description || "-"}
                    </td> */}

                                          {/* <td>
                                {i.description}
                              </td> */}

                                          {(rep.projectCategoryName === "Civil Works"
                                            // ||
                                            // rep.projectCategoryName === "Water Utility"
                                          ) ? (

                                            <td>{i.locationName || "-"}</td>

                                          ) : (

                                            <>
                                              <td>{i.fromChainage || "-"}</td>
                                              <td>{i.toChainage || "-"}</td>
                                            </>

                                          )}
                                          <td>{i.workItemCode}</td>
                                          <td>{i.side}</td>
                                          <td>{i.workActivity || "-"}</td>
                                          <td>{i.UOM}</td>
                                          {(rep.projectCategoryName === "Civil Works"
                                            // ||
                                            // rep.projectCategoryName === "Water Utility"
                                          ) && (
                                              <>
                                                <td>{i.nos ?? "-"}</td>
                                                <td>{i.length ?? "-"}</td>
                                                <td>{i.breadth ?? "-"}</td>
                                                <td>{i.depth ?? "-"}</td>
                                              </>
                                            )}
                                          <td>{i.projectQuantity}</td>
                                          <td>{i.workQuantity}</td>
                                          <td>{i.description}</td>
                                          <td>{i.remarks}</td>

                                        </tr>
                                      </>
                                    ))}
                                  </tbody>
                                </table>
                              )}

                              {/* <h6 className="mt-3">Material Consumption</h6> */}
                              {activeTab === "material" && (
                                <table className="table table-bordered">

                                  <thead>
                                    <tr>
                                      <th>Voucher</th>
                                      <th>Item Category</th>
                                      <th>Item</th>
                                      <th>Used</th>
                                      <th>Lost</th>
                                      <th>Damaged</th>
                                      <th>Returned</th>
                                      <th>Notes</th>
                                    </tr>
                                  </thead>

                                  <tbody>

                                    {rep.materialItems?.map((m, index) => (

                                      <tr key={index}>

                                        <td>{m.stockOutVoucherNo}</td>

                                        <td>{m.itemCategoryName || "-"}</td>

                                        <td>{m.itemCode}</td>

                                        <td>{m.quantityUsed}</td>

                                        <td>{m.quantityLost}</td>

                                        <td>{m.quantityDamaged}</td>

                                        <td>{m.quantityReturned}</td>

                                        <td>{m.notes}</td>

                                      </tr>

                                    ))}

                                  </tbody>

                                </table>

                              )}

                              {/* <h6 className="mt-3">Labour Details</h6> */}
                              {activeTab === "labour" && (
                                <table className="table table-bordered">

                                  <thead>

                                    <tr>

                                      <th>Vendor</th>

                                      <th>Skilled Labour</th>

                                      <th>Unskilled Labour</th>

                                      <th>Total</th>

                                      <th>Notes</th>

                                    </tr>

                                  </thead>

                                  <tbody>

                                    {rep.labourItems?.map((l, index) => (

                                      <tr key={index}>

                                        <td>{(() => {
                                          const contactName = [l.firstName, l.lastName].filter(Boolean).join(" ").trim();
                                          return contactName ? `${l.vendorName} - ${contactName}` : (l.vendorName || "-");
                                        })()}</td>

                                        <td>{l.skilledLabour}</td>

                                        <td>{l.unSkilledLabour}</td>

                                        <td>{(Number(l.skilledLabour || 0) + Number(l.unSkilledLabour || 0))}</td>

                                        <td>{l.notes}</td>

                                      </tr>

                                    ))}

                                  </tbody>

                                </table>

                              )}
                            </>

                          )}

                        </td>



                        <td>
                          <span
                            className={`badge ${rep.status === "PENDING"
                              ? "bg-info text-dark"
                              : rep.status === "APPROVED"
                                ? "bg-success"
                                : rep.status === "REJECTED"
                                  ? "bg-danger"
                                  : rep.status === "CANCELLED"
                                    ? "bg-dark"
                                    : "bg-secondary"
                              }`}
                            style={{ cursor: "pointer" }}
                            onClick={() => openStatusDetailPopup(rep)}
                            title="View status details"
                          >
                            {rep.status}
                          </span>
                        </td>

                        <td className="text-center">
                          {/* {rep.status === "PENDING" && (
                        <>
                          <button
                            className="btn btn-success btn-sm me-1"
                            disabled={rep.status !== "PENDING"}
                            // onClick={() => handleApprove(rep.id)}
                            onClick={() => handleApprove(rep)}
                          >
                            ✔
                          </button>

                          <button
                            className="btn btn-danger btn-sm me-1"
                            disabled={rep.status !== "PENDING"}
                            onClick={() => handleReject(rep)}
                          >
                            ✖
                          </button>


                          <button
                            className="btn btn-secondary btn-sm"
                            disabled={rep.status !== "PENDING"}
                            onClick={() => handleCancel(rep)}
                          >
                            cancel
                          </button>
                        </>

                      )} */}
                          {rep.status === "PENDING" && (
                            <>
                              {can("canApprove") && (
                                <button
                                  className="btn btn-success btn-sm me-1"
                                  onClick={() => handleApprove(rep)}
                                >
                                  ✔
                                </button>
                              )}

                              {can("canReject") && (
                                <button
                                  className="btn btn-danger btn-sm me-1"
                                  onClick={() => handleReject(rep)}
                                >
                                  ✖
                                </button>
                              )}

                              {can("canCancel") && (
                                <button
                                  className="btn btn-secondary btn-sm"
                                  onClick={() => handleCancel(rep)}
                                >
                                  cancel
                                </button>
                              )}
                            </>
                          )}
                        </td>

                      </tr>
                    )
                  })
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center text-muted">
                      No reports found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            <ReactPaginate
              // forcePage={currentPage - 1}
              forcePage={Math.max(0, currentPage - 1)}
              breakLabel="..."
              nextLabel="Next >"
              previousLabel="< Previous"
              onPageChange={(e) => setCurrentPage(e.selected + 1)}
              pageCount={pageCount}   // ✅ IMPORTANT
              pageRangeDisplayed={3}
              marginPagesDisplayed={2}
              containerClassName="pagination-container"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              activeClassName="active"
            />
          </div>

        </div>
      </div>
    </>

  );
}
